import { jsx as _jsx } from "react/jsx-runtime";
import { Gavel } from "@mui/icons-material";
export const TraditionalClubLogo = () => _jsx(Gavel, {});
//# sourceMappingURL=TraditionalClubLogo.js.map